import { render } from "./BundlesPage.vue?vue&type=template&id=3ac36626&scoped=true"
import script from "./BundlesPage.vue?vue&type=script&lang=js"
export * from "./BundlesPage.vue?vue&type=script&lang=js"

import "./BundlesPage.vue?vue&type=style&index=0&id=3ac36626&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac36626"]])

export default __exports__